"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = routerMiddleware;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _reactRouterRedux = require("react-router-redux");

var _router = require("./router");

function routerMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _reactRouterRedux.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        _router.history[method].apply(_router.history, (0, _toConsumableArray2["default"])(args));
      };
    };
  };
}